/*
  P97 — free-gift box placement, its panel, and its pop-up message.

  Nov 2 2026 (Marcos): "the gift box is still moving weird" + "it's popping up and I can't
  click out, and it hides the gift box. I want it displayed still in the same spot."
  On iPhone, opening the cart locks page scrolling, and Safari / Instagram's browser then
  move bottom-pinned things around (the box jumped up to the cart's Subtotal line). So:

  1. THE BOX IS PINNED BY JAVASCRIPT to the bottom-left of what's actually visible on the
     screen (window.visualViewport), cart open or closed, so it never jumps. 18px from the
     left and bottom edges, same corner as always.
  2. THE PANEL opens directly above the box and is sized to whatever room is left above it,
     so its header (with the X) is always on screen and it never covers the box. Tapping
     anywhere outside the panel closes it; tapping the box again also closes it.
  3. THE MESSAGE ("3 free gifts added", "Free gift added: ...") rises out of the box:
       - cart closed: just above the box, left-aligned with it
       - cart open:   same as closed - the normal wide message just above the box (Marcos,
                      Nov 3 2026: the narrow stacked label squeezed into the 76px strip looked
                      "too crammed", he liked the old wide one better; it can sit over the
                      cart's corner for the few seconds it shows)
  All set with !important because older rules (style#p97-gift-size in
  sections/other-footer.liquid) force bottom offsets with !important.

  Display only: never touches the cart, the drawer, or udesly's handlers.
*/
(function () {
  'use strict';

  var STRIP = 76;   // width of the left strip both carts leave open
  var EDGE = 18;    // box distance from the left and bottom edges
  var GAP = 10;     // space between the box and whatever sits above it

  function start() {
    var btn = document.getElementById('p97grBtn');
    if (!btn) return;
    var toast = document.getElementById('p97grToast');
    var panel = document.getElementById('p97grPanel');

    var st = document.createElement('style');
    st.id = 'p97-gift-toast-above';
    st.textContent =
      '#p97gr-scope .p97gr-btn{transition:none !important}' +
      '#p97gr-scope .p97gr-panel{overscroll-behavior:contain}' +
      '#p97gr-scope .p97gr-toast{transform:translateY(8px)}' +
      '#p97gr-scope .p97gr-toast.show{transform:none}' +
      '#p97gr-scope .p97gr-toast.p97-narrow{padding:8px 6px;font-size:9px;letter-spacing:.06em;line-height:1.3;text-align:center;overflow-wrap:anywhere;word-break:break-word}';
    document.head.appendChild(st);

    function setImp(el, prop, val) {
      if (!el) return;
      if (el.style.getPropertyValue(prop) !== val || el.style.getPropertyPriority(prop) !== 'important') {
        el.style.setProperty(prop, val, 'important');
      }
    }

    function cartOpen() {
      var c = document.documentElement.classList;
      return c.contains('p97-cartopen') || c.contains('p97c-lock');
    }

    /* what is actually visible right now (phones: excludes Safari's bars) */
    function view() {
      var vv = window.visualViewport;
      if (vv) return { top: vv.offsetTop, left: vv.offsetLeft, w: vv.width, h: vv.height };
      return { top: 0, left: 0, w: window.innerWidth, h: window.innerHeight };
    }

    function placeBox() {
      var v = view();
      var h = btn.offsetHeight || 48;
      var top = Math.round(v.top + v.h - EDGE - h);
      setImp(btn, 'bottom', 'auto');
      setImp(btn, 'top', top + 'px');
      setImp(btn, 'left', Math.round(v.left + EDGE) + 'px');
      setImp(btn, 'transform', 'none');
      setImp(btn, 'translate', 'none');
      /* self-check: if the browser still drew it somewhere else (iPhone with the cart's
         scroll lock on), nudge it by the difference so it lands in the corner */
      var r = btn.getBoundingClientRect();
      var want = v.top + v.h - EDGE;
      var off = Math.round(want - r.bottom);
      if (r.height && Math.abs(off) > 1) setImp(btn, 'top', (top + off) + 'px');
    }

    function placePanel() {
      if (!panel) return;
      var v = view();
      var br = btn.getBoundingClientRect();
      var boxTop = br.width ? br.top : (v.top + v.h - EDGE - 48);
      var room = Math.max(160, Math.round(boxTop - GAP - v.top - 12));
      setImp(panel, 'top', 'auto');
      setImp(panel, 'bottom', Math.round(window.innerHeight - boxTop + GAP) + 'px');
      setImp(panel, 'left', Math.round(v.left + EDGE) + 'px');
      setImp(panel, 'max-height', room + 'px');
    }

    function placeToast() {
      if (!toast) return;
      var br = btn.getBoundingClientRect();
      if (!br.width) return;
      var vw = window.innerWidth || document.documentElement.clientWidth;
      var narrow = false; // was: cartOpen() && vw <= 900 - the narrow cart-open label is retired (Nov 3 2026)

      if (narrow !== toast.classList.contains('p97-narrow')) {
        toast.classList.toggle('p97-narrow', narrow);
      }
      setImp(toast, 'bottom', 'auto');
      if (narrow) {
        var w = STRIP - 12;
        setImp(toast, 'width', w + 'px');
        setImp(toast, 'max-width', w + 'px');
        setImp(toast, 'left', Math.round(Math.max(6, br.left + (br.width - w) / 2)) + 'px');
      } else {
        setImp(toast, 'width', 'auto');
        setImp(toast, 'max-width', Math.max(160, Math.min(320, Math.round(vw - br.left - 16))) + 'px');
        setImp(toast, 'left', Math.round(br.left) + 'px');
      }
      var th = toast.offsetHeight || 40;
      setImp(toast, 'top', Math.round(br.top - GAP - th) + 'px');
    }

    var raf = 0;
    function placeAll() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        placeBox();
        placePanel();
        placeToast();
      });
    }

    /* tap outside the panel (anywhere but the panel or the box) closes it */
    function outside(e) {
      if (!panel || !panel.classList.contains('open')) return;
      var t = e.target;
      if (panel.contains(t) || btn.contains(t)) return;
      panel.classList.remove('open');
      btn.setAttribute('aria-expanded', 'false');
    }
    document.addEventListener('pointerdown', outside, true);
    document.addEventListener('touchstart', outside, { capture: true, passive: true });

    if (toast) {
      toast.style.transition = 'transform .25s, opacity .25s';
      // re-place the instant a message is shown. Watches class + text only.
      new MutationObserver(placeToast).observe(toast, { attributes: true, attributeFilter: ['class'], childList: true, characterData: true, subtree: true });
    }
    if (panel) new MutationObserver(placeAll).observe(panel, { attributes: true, attributeFilter: ['class'] });
    // the cart opening/closing changes the screen (and the message layout)
    new MutationObserver(function () { placeAll(); setTimeout(placeAll, 350); })
      .observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', placeAll);
    window.addEventListener('scroll', placeAll, { passive: true });
    window.addEventListener('orientationchange', function () { setTimeout(placeAll, 300); });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', placeAll);
      window.visualViewport.addEventListener('scroll', placeAll);
    }
    placeAll();
    setTimeout(placeAll, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
